// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-template-wrapper {
  padding: 0px 16px 5px 16px;
  display: inline-block;
  width: 100%;
}
.chart-template-wrapper .charts-body-info {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
}
.chart-template-wrapper .charts-body-info h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}

polyline {
  opacity: 0.3;
  stroke: black;
  stroke-width: 1px;
  fill: none;
}

.piechartDiv {
  overflow-x: auto;
}

.lineChartChildDiv .no-show {
  display: none;
}

.chart-template-wrapper .piechartDiv .lineChartChildDiv .tooltip, .chart-template-wrapper .piechartDiv .lineChartChildDiv .tooltipDonut {
  background: var(--sdk-gloabl-text-color);
  color: var(--sdk-global-white-bg);
  font-size: 12px;
  left: 130px;
  padding: 10px;
  position: absolute;
  text-align: center;
  top: 95px;
  width: 80px;
  z-index: 10;
  opacity: 1;
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/pieChart/pieChart.scss"],"names":[],"mappings":"AAEA;EACI,0BAAA;EACA,qBAAA;EACA,WAAA;AADJ;AAEI;EACI,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAAR;AACQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACZ;;AAIA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAKI;EACI,aAAA;AAFR;;AASY;EACI,wCAAA;EACA,iCAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;AANhB","sourcesContent":["\n\n.chart-template-wrapper{\n    padding: 0px 16px 5px 16px;\n    display: inline-block;\n    width: 100%;\n    .charts-body-info{\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--sdk-global-white-bg);\n        padding: 16px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 15px;\n        h1{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n        }\n    }\n}\n\npolyline{\n    opacity: .3;\n    stroke: black;\n    stroke-width: 1px;\n    fill: none;\n}\n\n.piechartDiv {\n    overflow-x: auto;\n}\n\n.lineChartChildDiv {\n    .no-show {\n        display: none;\n    }\n}\n\n.chart-template-wrapper {\n    .piechartDiv {\n        .lineChartChildDiv {\n            .tooltip {\n                background: var(--sdk-gloabl-text-color);\n                color: var(--sdk-global-white-bg);\n                font-size: 12px;\n                left: 130px;\n                padding: 10px;\n                position: absolute;\n                text-align: center;\n                top: 95px;\n                width: 80px;\n                z-index: 10;\n                opacity: 1;\n                display: none;\n            }\n            .tooltipDonut {\n                @extend .tooltip\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
